// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3Eeyv","productName":"Table_productName__3adGS"};